import { Card, CardContent, Typography, Stack, Box, Chip, IconButton } from '@mui/material';
import { Users, BookOpen, Clock, MoreVertical, Trash2 } from 'lucide-react';
import { SubjectBadge } from './SubjectBadge';

export function TeacherAssignmentCard({ assignment, onDelete }) {
  return (
    <Card variant="outlined" sx={{ '&:hover': { boxShadow: 1 } }}>
      <CardContent>
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1 }}>
              <Typography variant="h6" fontWeight={600}>
                {assignment.className} - {assignment.sectionName}
              </Typography>
              {assignment.isClassTeacher && (
                <Chip label="Class Teacher" size="small" color="primary" variant="outlined" />
              )}
            </Stack>
            <SubjectBadge subject={assignment.subject} />
          </Box>
          {onDelete && (
            <IconButton size="small" color="error" onClick={() => onDelete(assignment.id)}>
              <Trash2 size={18} />
            </IconButton>
          )}
        </Stack>

        <Stack direction="row" spacing={3} color="text.secondary" mt={3}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Users size={16} />
            <Typography variant="body2">40 Students</Typography>
          </Stack>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <BookOpen size={16} />
            <Typography variant="body2">{assignment.session}</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
